import { Controller } from "@hotwired/stimulus";
import { client } from "./../components/Client";

export default class extends Controller {
  static targets = ["descriptionLabel"]
  static values = {
    courseId: Number,
    videosDuration: {
      type: String,
      default: "0.0"
    },
  }

  connect() {
    this.videosDuration = parseFloat(this.videosDurationValue);
  }

  async generateDescription() {
    let content = ""

    if (!isNaN(this.videosDuration) && this.videosDuration > 0) {
      const res = await client.getCourseDescriptionFromAi(this.courseIdValue)
      content = res
    }
    else {
      content = window.t('course.ai_note')
    }

    this.dispatch("generateDescription", { detail: { content } });
  }
}
